import { render, staticRenderFns } from "./ProductBadgeDescription.vue?vue&type=template&id=42080abe&scoped=true&"
import script from "./ProductBadgeDescription.vue?vue&type=script&lang=js&"
export * from "./ProductBadgeDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProductBadgeDescription.vue?vue&type=style&index=0&id=42080abe&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42080abe",
  null
  
)

export default component.exports